"use client";

export const CategorySelector = ({
  title,
  categoriesWithProducts,
}: {
  title: string | undefined;
  categoriesWithProducts: {
    __typename?: "ProductCategories";
    id: number;
    name: string;
    popularity: number;
  }[];
}) => {
  const handleCategoryClick = (categoryId: number) => {
    // Find the element with the matching ID
    const element = document.getElementById(`category-${categoryId}`);

    if (element) {
      // Smooth scroll to the element
      element.scrollIntoView({
        behavior: "smooth",
        block: "start", // This ensures we scroll to the top of the element
      });
    }
  };

  return (
    <div className="flex flex-col lg:py-20 sm:py-10 w-full lg:px-[12rem] sm:px-4 lg:gap-12 sm:gap-8 sm:border-b-0 ">
      <p className="config-h2 lg:w-1/2 sm:w-3/4">{title}</p>

      <div className="flex flex-wrap lg:gap-4 sm:gap-2 overflow-x-scroll no-scrollbar">
        {categoriesWithProducts.map((category) => {
          return (
            <button
              className="border rounded-full py-2 w-fit px-6 border-black cursor-pointer min-w-[120px] flex justify-center transition-all duration-150 hover:bg-[#efefef]"
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              type="button"
            >
              <p className="config-p3 lg:!text-sm sm:!text-xs whitespace-nowrap">
                {category.name}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};
